import React, { useEffect, useState } from 'react';
import ScrollToTop from 'components/ScrollToTop';
// import Router from 'router';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as authActions from 'store/actions/auth';
import * as commonActions from 'store/actions/common';
import { ToastContainer } from '../components/toast';
import 'react-toastify/dist/ReactToastify.css';
import 'styles/generic.scss';
import RouterIndex from 'router';
import { BrowserRouter as Router, useHistory } from 'react-router-dom';

const App = ({ onAppLoad, ...props }) => {
  useEffect(() => {
    onAppLoad();
  }, [onAppLoad]);

  return (
    <div>
      <div>
        <RouterIndex {...props} />
        <ToastContainer />
      </div>
    </div>
  );
};

const mapStateToProps = ({ common: { isAuthenticated } }) => ({
  isAuthenticated,
});

export default connect(mapStateToProps, { ...authActions, ...commonActions })(
  App,
);
